export const URL_BASE = process.env.REACT_APP_URL_API;
export const GET_DEPARTMENTS = "api/Admin/Departments";
export const GET_MUNICIPALITIES = "api/Admin/Municipalities/";
export const CREATE_STORE = "api/Admin/CreateStore/";
export const LOGIN = "api/Admin/Login/";
export const GET_CATEGORIES = "api/Admin/Categories";
export const CREATE_CATEGORY = "api/Admin/CreateCategory/";
export const GET_CATEGORIES_STORE = "api/Admin/Categories/Store/";
export const CREATE_CATEGORY_STORE = "api/Admin/CreateCategory/Store";
export const GET_SCHEDULE_STORE = "api/Admin/Schedules/Store/";
export const CREATE_SCHEDULE_STORE = "api/Admin/CreateSchedule/Store/";
export const GET_PRODUCTS_STORE = "api/Admin/Products/Store/";
export const GET_STORES = "api/Admin/Stores";

export const GET_ORDERS_STORE = "api/Admin/Orders/Store/";
export const GET_STATES_ORDER = "api/Admin/StatesOrder/";

export const UPDATE_PRODUCT_STATE = "api/Admin/Update/Product/State";
export const UPLOAD_FILE_PRODUCT = "api/Admin/Upload/File/Product"
export const CREATE_PRODUCT_STORE = "api/Admin/Create/Product/Store"
export const UPDATE_STORE_STATE = "api/Admin/Update/Store/State"
export const UPDATE_CATEGORY_STATE = "api/Admin/Update/Category/State"
export const UPDATE_CATEGORY_STORE_STATE = "api/Admin/Update/Category/Store/State"

export const UPDATE_STORE = "api/Admin/Update/Store"
export const UPLOAD_FILE_STORE = "api/Admin/Upload/File/Store"
export const GET_STORE = "api/Admin/Store/"
export const GET_REPORTS_DAY = "api/Admin/Dashboard/Reports/Day/"
export const GET_DATA_ORDERS_DAY = "api/Admin/Dashboard/Data/Orders/Day/"
export const UPDATE_PRODUCT_STORE = "api/Admin/Update/Product/Store/"
export const GET_PRODUCTS_STORE_CATEGORY = "api/Admin/Products/Store/Category/"
export const GET_ORDERS_DETAILS = "api/Admin/Orders/Details/"
export const GET_ORDERS_PENDING = "api/Admin/Dashboard/Orders/Pending/Day/"
export const GET_STATES = "api/Admin/States"
export const GET_ORDERS_FILTER_DATE = "api/Admin/Orders/Filter/Date/"
export const GET_CUSTOMERS_STORE = "api/Admin/Customers/Store/"
export const UPDATE_CATEGORY_STORE = "api/Admin/Update/Category/Store/"
export const UPDATE_SCHEDULE_STORE = "api/Admin/Update/Schedule/Store/"